import React, { Component } from 'react';
import { InputGroup, Button, FormControl, Form, Spinner } from "react-bootstrap";
import ReactPasswordStrength from 'react-password-strength';
import { toast } from 'react-toastify';
import imgCamelLogo from '../../assets/images/main-logo-white.png';
import './ChangePasswordForm.scss';

const ValidationRules = {
  MinimumLength: 12,
  RequireLowercase: false,
  RequireNumbers: true,
  RequireSymbols: false,
  RequireUppercase: true,
  MinimumScore: 4
};

class ChangePaswordForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPassword: '',
      newPassword: '',
      // confirmPassword: '',
      isLoading: false
    };
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  confirmNewPassword = () => {
    const {
      currentPassword,
      newPassword,
      // confirmPassword
    } = this.state;

    if (currentPassword !== '' &&
      newPassword !== '' &&
      // newPassword === confirmPassword &&
      this.state.newPassword.length >= ValidationRules.MinimumLength) {
      return false;
    }

    return true;
  }

  onSubmitChange = () => {
    const { currentPassword, newPassword } = this.state;
    this.setState({ isLoading: true })

    this.props.Auth.signIn(this.props.cognitoUser.username, currentPassword)
      .then(user => {
        // const { requiredAttributes } = user.challengeParam; // the array of required attributes, e.g ['email', 'phone_number']
        this.props.Auth.changePassword(
          user,               // the Cognito User Object
          currentPassword,    // Old password
          newPassword,        // the new password
        ).then(async user => {
          toast.success('Changed password successfully.', {
            position: toast.POSITION.TOP_RIGHT
          });
          this.setState({ isLoading: false });
          this.props.onConfirm();
        }).catch(e => {
          toast.error('Failed to change password: ' + e.message, {
            position: toast.POSITION.TOP_RIGHT
          });
          this.setState({ isLoading: false });
        });
      }).catch(e => {
        toast.error('Failed to change password: ' + e.message, {
          position: toast.POSITION.TOP_RIGHT
        });
        this.setState({ isLoading: false });
      });
  }

  render() {
    const { isLoading } = this.state;

    return (
      <Form className="change-password-form-container">
        <div className="form-header">
          <img src={imgCamelLogo} alt="logo" />
        </div>
        <div className="p-4">
          <h3>Change Password</h3>
          <div className="passwords-box">
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text>Current Password</InputGroup.Text>
              </InputGroup.Prepend>
              <FormControl
                autoFocus
                type="password"
                name="currentPassword"
                placeholder="Current Password"
                value={this.state.currentPassword}
                onChange={this.handleChange}
                autoComplete="current-password"
              />
            </InputGroup>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text>New Password</InputGroup.Text>
              </InputGroup.Prepend>
              <ReactPasswordStrength
                className="customClass"
                minLength={ValidationRules.MinimumLength}
                minScore={ValidationRules.MinimumScore}
                scoreWords={['weak', 'okay', 'good', 'strong', 'stronger']}
                changeCallback={(e) => this.handleChange({ target: { name: 'newPassword', value: e.password } })}
                inputProps={{ name: "new_password_input", className: "form-control", autoComplete: "new-password" }}
              />
            </InputGroup>
            {/* <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text>Confirm Password</InputGroup.Text>
              </InputGroup.Prepend> 
               <FormControl
                autoFocus
                type="password"
                name="confirmPassword"
                placeholder="Confirm Password"
                value={this.state.confirmPassword}
                onChange={this.handleChange}
                autoComplete="ConfirmPassword"
              /> 
            </InputGroup> */}
          </div>
          <div className="actions">
            <Button variant="outline-danger" className="mr-2" size="sm" onClick={this.props.onClose}>CANCEL</Button>
            <Button
              variant="outline-danger"
              className="mr-2"
              size="sm"
              onClick={this.onSubmitChange}
              disabled={this.confirmNewPassword()}
            >
              {isLoading && <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              }
              CHANGE
            </Button>
          </div>
        </div>
      </Form>
    );
  }
}

export default ChangePaswordForm;
